module.exports = __webpack_public_path__ + "static/tamanikhlas-black-d70780eb9487bf7337fbad4a99a08674.svg";